export enum ChartType {
  histogram = 'histogram',
  bar = 'bar'
}
